export default __webpack_public_path__ + "6807ae2a88a16e5a804856379fa94cb8.png";